import { cn } from "@/lib/utils"
import { FileQuestion, PackageSearch, Shield, Truck } from "lucide-react"
import Link from "next/link"

export const Info2 = ({ className }: { className?: string }) => {
  return (
    <div className={cn("border-t border-[#c5c5c5] pt-8", className)}>
      <h3 className="mb-6 text-[16px] font-semibold text-title">
        Resources you may need:
      </h3>

      <div className="grid grid-cols-1 gap-4">
        <Link
          href="/help-faqs"
          className="hover_shadow-sm duration-200 flex items-center rounded-[10px] border  border-[#c5c5c5] p-4 transition hover_border-primary"
        >
          <FileQuestion className="mr-3 h-5 w-5 text-title" />
          <span className="text-title underline">FAQ Page</span>
        </Link>

        <Link
          href="/shipping-return-policy"
          className="hover_shadow-sm duration-200 flex items-center rounded-[10px] border  border-[#c5c5c5] p-4 transition hover_border-primary"
        >
          <Truck className="mr-3 h-5 w-5 text-title" />
          <span className="text-title underline">Shipping & Return Policy</span>
        </Link>

        <Link
          href="/track-your-order"
          className="hover_shadow-sm duration-200 flex items-center rounded-[10px] border  border-[#c5c5c5] p-4 transition hover_border-primary"
        >
          <PackageSearch className="mr-3 h-5 w-5 text-title" />
          <span className="text-title underline">Track Your Order</span>
        </Link>

        <Link
          href="/warranty"
          className="hover_shadow-sm duration-200 flex items-center rounded-[10px] border  border-[#c5c5c5] p-4 transition hover_border-primary"
        >
          <Shield className="mr-3 h-5 w-5 text-title" />
          <span className="text-title underline">Lifetime Warranty</span>
        </Link>
      </div>
    </div>
  )
}
